const updateFormState = (state = {}, payload = {}) => {
  // console.log("state", state);
  return {
    ...state,
    ...payload,
  };
};

export default updateFormState;
